(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pxu-countdown-timer-bar"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class CountdownTimerBarSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.countdown = this.query('[data-pxu-countdown-timer-bar-countdown]');
    this.days = this.query('[data-pxu-countdown-timer-bar-countdown-day]');
    this.hours = this.query('[data-pxu-countdown-timer-bar-countdown-hrs]');
    this.minutes = this.query('[data-pxu-countdown-timer-bar-countdown-min]');
    this.seconds = this.query('[data-pxu-countdown-timer-bar-countdown-sec]');
    this.dateTime = this.data.countdownDatetime;

    this.targetDate = this.dateTime ? Date.parse(this.dateTime) : null;
    this.daysInMs = 1000 * 60 * 60 * 24;
    this.hoursInMs = this.daysInMs / 24;
    this.minutesInMs = this.hoursInMs / 60;
    this.secondsInMs = this.minutesInMs / 60;
    this.timeoutId = null;
    this.isLoading = true;

    this.onMount();
  }

  onMount() {
    this.startTimer();
  }

  onUnmount() {
    this.stopTimer();
  }
  updateLoadingState() {
    // Remove the loading class once the countdown is ready.
    this.countdown.classList.remove('pxu-countdown-timer__countdown--loading');
  }

  startTimer() {
    const interval = 1000;
    let expectedTime = Date.now() + interval;

    // If the target date has already passed, handle countdown completion.
    if (this.targetDate <= Date.now()) {
      this.updateLoadingState();
      this.handleCountDownComplete();
      return;
    }

    const countDown = () => {
      const currentDate = Date.now();
      const timeDiff = this.targetDate - currentDate;

      // If time difference is zero or less, stop the timer and handle countdown completion.
      if (timeDiff <= 0) {
        this.stopTimer();
        this.handleCountDownComplete();
        return;
      }

      // Convert the time difference, calculate the drift, and adjust the expected time.
      const remainingTime = this.convertTime(timeDiff);
      const drift = currentDate - expectedTime;
      expectedTime += interval;

      // Update the loading state and update the DOM with the remaining time.
      if (this.isLoading) this.updateLoadingState();
      this.updateDom(remainingTime);

      this.timeoutId = setTimeout(countDown, Math.max(0, interval - drift));
    };

    this.timeoutId = setTimeout(countDown, interval);
  }

  stopTimer() {
    // Stop the countdown and clear the timeout.
    clearTimeout(this.timeoutId);
  }

  convertTime(timeInMs) {
    // Convert the time difference into days, hours, minutes, and seconds.
    const days = parseInt(timeInMs / this.daysInMs, 10);
    timeInMs -= days * this.daysInMs;

    const hours = parseInt(timeInMs / this.hoursInMs, 10);
    timeInMs -= hours * this.hoursInMs;

    const minutes = parseInt(timeInMs / this.minutesInMs, 10);
    timeInMs -= minutes * this.minutesInMs;

    const seconds = parseInt(timeInMs / this.secondsInMs, 10);

    // Return an object with the calculated time.
    return { days, hours, minutes, seconds };
  }

  updateDom(dateObj) {
    // Update DOM elements with the remaining time.
    const { days, hours, minutes, seconds } = dateObj;
    this.days.textContent = days;
    this.hours.textContent = hours;
    this.minutes.textContent = minutes;
    this.seconds.textContent = seconds;
  }

  handleCountDownComplete() {
    // Update the DOM once the countdown is complete.
    this.updateDom({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    });

    // Add the complete class once the countdown is complete.
    this.countdown.classList.add('pxu-countdown-timer-bar__countdown--complete');
  }
}

document.querySelectorAll('[data-pxu-countdown-timer-bar]').forEach(($section) => {
  Section.init($section, CountdownTimerBarSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.CountdownTimerBarSection = CountdownTimerBarSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-scrolling-text"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;

class ScrollingTextSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.contentItems = this.$root.querySelectorAll('[data-scrolling-text-content]');

    this.onMount();
  }

  // Section lifecycle

  onMount() {
    this._initScroll();
  }

  _initScroll() {
    this.contentItems.forEach(el => {
      const textItems = el.querySelectorAll('[data-scrolling-text-content-item]');
      const width = el.offsetWidth;

      // Calculate the total width of all marquee items.
      const totalItemWidth = [...textItems].reduce((total, item) => total + item.offsetWidth, 0);

      // Calculate the number of marquee items needed to fill the container.
      const numItems = Math.ceil(width / totalItemWidth);

      // Clone and append marquee items.
      for (let i = 0; i < numItems; i++) {
        textItems.forEach(item => {
          const clone = item.cloneNode(true);
          el.appendChild(clone);
        });
      }
    });

    this._observeAnimations();
  }

  _observeAnimations() {
    // Initiate animations in viewport.
    this.observer = new IntersectionObserver(debounce(([entry]) => {
      const { isIntersecting } = entry;
      this.$root.classList.toggle('pxu-scrolling-text--is-animated', isIntersecting);
    }, 100));

    this.observer.observe(this.$root);
  }

  onUnmount(){
    this.observer.unobserve(this.$root);
  }
}

document.querySelectorAll('[data-pxu-scrolling-text]').forEach(($section) => {
  Section.init($section, ScrollingTextSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.ScrollingTextSection = ScrollingTextSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rebajas-verano"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.__rvInit) return;
    root.__rvInit = true;

    /* count-up numerals */
    var counters = root.querySelectorAll('[data-rv-count]');
    if ('IntersectionObserver' in window && counters.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target; io.unobserve(el);
          if (el.__done) return; el.__done = true;
          var target = parseInt(el.getAttribute('data-rv-count'), 10) || 0;
          var suf = el.getAttribute('data-rv-suffix') || '';
          var dur = 1100, t0 = performance.now();
          (function tick(now) {
            var p = Math.min(1, (now - t0) / dur);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(eased * target) + suf;
            if (p < 1) requestAnimationFrame(tick);
          })(t0);
        });
      }, { threshold: 0.6 });
      counters.forEach(function (c) { io.observe(c); });
    }

    /* quiz */
    var quiz = root.querySelector('[data-rv-quiz]');
    if (!quiz) return;
    var GEN = { el: 'Para él', ella: 'Para ella', indif: '' };
    var MOM = { diario: 'Diario', especial: 'Especial' };
    var state = { step: 1, caracter: null, genero: null, momento: null };

    function screens() { return quiz.querySelectorAll('[data-rv-screen]'); }
    function show(name) {
      screens().forEach(function (s) {
        var on = s.getAttribute('data-rv-screen') === String(name);
        s.toggleAttribute('data-rv-hidden', !on);
        if (on) { s.style.animation = 'none'; void s.offsetWidth; s.style.animation = 'rv-rise-sm .42s cubic-bezier(.22,.61,.36,1) both'; }
      });
      var isResult = name === 'result';
      var prog = quiz.querySelector('[data-rv-progress]');
      if (prog) prog.toggleAttribute('data-rv-hidden', isResult);
    }
    var STEP_LABELS = { 1: 'Paso 1 de 3 · vamos rápido', 2: 'Paso 2 de 3 · ya casi', 3: 'Último y te digo cuál' };
    function setProgress() {
      var step = Math.min(state.step, 3);
      var label = quiz.querySelector('[data-rv-steplabel]');
      if (label) label.textContent = STEP_LABELS[step] || ('Paso ' + step + ' de 3');
      var fill = quiz.querySelector('[data-rv-fill]');
      if (fill) fill.style.width = (step * 33.34) + '%';
    }
    var FAM_EMOJI = { citrico: '🍋', marino: '💧', aromatico: '🌿', floral: '🌸', tropical: '🌴' };
    function renderResult() {
      var car = state.caracter;
      quiz.querySelectorAll('[data-rv-fampanel]').forEach(function (p) {
        p.toggleAttribute('data-rv-hidden', p.getAttribute('data-rv-fampanel') !== car);
      });
      var emo = quiz.querySelector('[data-rv-result-emoji]');
      if (emo) { emo.textContent = FAM_EMOJI[car] || '☀️'; emo.setAttribute('data-fam', car || ''); }
      var panel = quiz.querySelector('[data-rv-fampanel="' + car + '"]');
      /* género elegido: SOLO Femenino/Masculino + Unisex (nunca el contrario), en ese orden y reordenando el DOM */
      if (panel) {
        var want = state.genero === 'ella' ? 'Femenino' : (state.genero === 'el' ? 'Masculino' : null);
        var cards = [].slice.call(panel.querySelectorAll('[data-rv-g]'));
        var grid = cards.length ? cards[0].parentNode : null;
        var pick = [];
        if (want) {
          cards.forEach(function (c) { if (c.getAttribute('data-rv-g') === want) pick.push(c); });
          cards.forEach(function (c) { if (c.getAttribute('data-rv-g') === 'Unisex' && pick.indexOf(c) === -1) pick.push(c); });
          if (!pick.length) pick = cards.slice();   /* sin datos de género en la colección: mejor algo que nada */
        } else {
          pick = cards.slice();
        }
        pick = pick.slice(0, 3);
        cards.forEach(function (c) { c.style.display = 'none'; });
        pick.forEach(function (c) { c.style.display = 'contents'; if (grid) grid.appendChild(c); });
      }
      var label = panel ? panel.getAttribute('data-rv-fam-label') : '';
      var title = quiz.querySelector('[data-rv-result-title]');
      if (title && label) title.textContent = 'Tu verano huele a ' + label + '.';
      var bits = [];
      if (state.genero && GEN[state.genero]) bits.push(GEN[state.genero]);
      if (state.momento && MOM[state.momento]) bits.push(MOM[state.momento]);
      var sub = quiz.querySelector('[data-rv-result-sub]');
      if (sub) sub.textContent = (bits.length ? bits.join(' · ') + ' — ' : '') + 'aquí van tres que te encajan.';
    }
    function go(step) { state.step = step; if (step >= 4) { show('result'); renderResult(); } else { show(step); setProgress(); } }

    quiz.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-rv-field]');
      if (pick) {
        state[pick.getAttribute('data-rv-field')] = pick.getAttribute('data-rv-value');
        var gold = getComputedStyle(root).getPropertyValue('--rv-gold').trim() || '#B89860';
        var group = pick.parentNode ? pick.parentNode.querySelectorAll('[data-rv-field]') : [];
        group.forEach(function (b) { b.style.borderColor = ''; });
        pick.style.borderColor = gold;
        pick.style.animation = 'rv-pop .3s ease';
        var next = state.step + 1;
        setTimeout(function () { pick.style.animation = ''; go(next); }, 230);
        return;
      }
      if (e.target.closest('[data-rv-back]')) { go(Math.max(1, state.step - 1)); return; }
      if (e.target.closest('[data-rv-restart]')) {
        state = { step: 1, caracter: null, genero: null, momento: null };
        var ef = quiz.querySelector('[data-rv-email-form]'), ed = quiz.querySelector('[data-rv-email-done]'), ei = quiz.querySelector('[data-rv-email]');
        if (ef) ef.removeAttribute('data-rv-hidden'); if (ed) ed.setAttribute('data-rv-hidden', ''); if (ei) ei.value = '';
        go(1); return;
      }
      if (e.target.closest('[data-rv-email-save]')) {
        var input = quiz.querySelector('[data-rv-email]');
        if (input && (input.value || '').indexOf('@') > -1) {
          rvKlaviyoSubscribe(input.value.trim(), state.caracter);   // lista single opt-in WVN2rp + familia del quiz
          var f = quiz.querySelector('[data-rv-email-form]'), d = quiz.querySelector('[data-rv-email-done]');
          if (f) f.setAttribute('data-rv-hidden', ''); if (d) d.removeAttribute('data-rv-hidden');
        }
        return;
      }
    });

    setProgress();
  }

  // --- Klaviyo: alta en lista (single opt-in) con la familia del quiz como propiedad ---
  var RV_KLAVIYO_COMPANY = 'QUKJkq';
  var RV_KLAVIYO_LIST = 'WVN2rp';
  function rvKlaviyoSubscribe(email, familia) {
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + RV_KLAVIYO_COMPANY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Quiz Rebajas de Verano',
            profile: { data: { type: 'profile', attributes: { email: email, properties: familia ? { quiz_familia: familia } : {} } } }
          },
          relationships: { list: { data: { type: 'list', id: RV_KLAVIYO_LIST } } }
        } })
      }).catch(function () {});
    } catch (e) {}
  }

  // --- Carrito AJAX: interceptar los forms data-rv-atc y usar el flujo nativo del tema (abre el drawer) ---
  function rvAtcInit() {
    if (window.__rvAtc) return; window.__rvAtc = true;
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest && e.target.closest('form[data-rv-atc]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]'); if (btn) btn.disabled = true;
      fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form)
      })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) btn.disabled = false;
        if (!res.ok || (res.data && res.data.status)) return;   // agotado/error: no abrir el drawer
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: res.data } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () { if (btn) btn.disabled = false; });
    });
  }

  // --- Carrusel v2: arrastre con inercia en desktop (en móvil, swipe nativo con snap) ---
  function rvRailDrag() {
    document.querySelectorAll('.rv-rail').forEach(function (r) {
      if (r.__rvDrag) return; r.__rvDrag = true;
      var down = false, moved = false, sx = 0, sl = 0, vel = 0, lastX = 0, lastT = 0, raf = null;
      r.style.cursor = 'grab';
      function stopGlide() { if (raf) { cancelAnimationFrame(raf); raf = null; } }
      r.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        stopGlide(); down = true; moved = false;
        sx = e.clientX; sl = r.scrollLeft; lastX = e.clientX; lastT = performance.now(); vel = 0;
        r.style.cursor = 'grabbing';
        try { r.setPointerCapture(e.pointerId); } catch (x) {}
      });
      r.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true;
        r.scrollLeft = sl - dx;
        var now = performance.now(), dt = now - lastT;
        if (dt > 0) { vel = (e.clientX - lastX) / dt; lastX = e.clientX; lastT = now; }
      });
      function up() {
        if (!down) return; down = false; r.style.cursor = 'grab';
        var v = vel * 15;                                    /* px por frame aprox */
        if (Math.abs(v) > 2) {
          (function glide() {
            v *= 0.94; r.scrollLeft -= v;
            raf = Math.abs(v) > 0.4 ? requestAnimationFrame(glide) : null;
          })();
        }
      }
      r.addEventListener('pointerup', up); r.addEventListener('pointercancel', up); r.addEventListener('pointerleave', up);
      r.addEventListener('wheel', stopGlide, { passive: true });
      r.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  // --- Carrusel v2: flechas (desktop) + estado en los extremos ---
  function rvRailArrows() {
    if (!window.__rvArrowClick) {
      window.__rvArrowClick = true;
      document.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-rv-prev],[data-rv-next]');
        if (!b) return;
        var wrap = b.closest('.rv-rail-wrap'); var r = wrap && wrap.querySelector('.rv-rail');
        if (!r) return;
        var card = r.querySelector('.rv-card');
        var step = card ? (card.getBoundingClientRect().width + 18) * 2 : r.clientWidth * 0.7;
        r.scrollBy({ left: b.hasAttribute('data-rv-next') ? step : -step, behavior: 'smooth' });
      });
    }
    document.querySelectorAll('.rv-rail-wrap').forEach(function (w) {
      var r = w.querySelector('.rv-rail'); if (!r || r.__rvEnds) return; r.__rvEnds = true;
      function upd() {
        var max = r.scrollWidth - r.clientWidth - 2;
        w.toggleAttribute('data-at-start', r.scrollLeft <= 2);
        w.toggleAttribute('data-at-end', r.scrollLeft >= max);
      }
      r.addEventListener('scroll', function () {
        if (r.__rvST) return;
        r.__rvST = setTimeout(function () { r.__rvST = null; upd(); }, 90);
      }, { passive: true });
      upd();
    });
  }

  // --- Reveals cross-browser: .rv-io / .rv-io-group aparecen al entrar en viewport (iOS incluido) ---
  function rvIO() {
    var root = document.querySelector('.rv-landing'); if (!root || root.__rvIO) return; root.__rvIO = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    root.classList.add('rv-js');
    var els = root.querySelectorAll('.rv-io,.rv-io-group');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-vis'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
    /* red de seguridad: nada se queda invisible */
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-vis'); }); }, 3000);
  }

  // --- Carrusel: entrada suave de las tarjetas una sola vez al entrar en viewport (stagger por CSS) ---
  function rvRailReveal() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('.rv-rail').forEach(function (r) {
      if (r.__rvRev) return; r.__rvRev = true;
      r.classList.add('rv-anim');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          r.classList.add('is-in'); io.unobserve(r);
        });
      }, { threshold: 0.2 });
      io.observe(r);
      /* red de seguridad: si el observer no dispara (tab oculta, etc.), mostrar igualmente */
      setTimeout(function () { r.classList.add('is-in'); }, 2500);
    });
  }

  function boot() { rvAtcInit(); rvRailDrag(); rvRailArrows(); rvRailReveal(); rvIO(); document.querySelectorAll('.rv-landing').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.rv-landing'); if (r) { r.__rvInit = false; r.__rvIO = false; init(r); rvRailDrag(); rvRailArrows(); rvRailReveal(); rvIO(); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
